// extracted by mini-css-extract-plugin
export default {"container":"Clubs_container__XI4aP","header":"Clubs_header__kPUnj","clubs":"Clubs_clubs__P6H0w"};